import BlurFade from '#app/components/magicui/blur-fade.tsx'
import BlurFadeText from '#app/components/magicui/blur-fade-text.tsx'
import {
	Avatar,
	AvatarFallback,
	AvatarImage,
} from '#app/components/ui/avatar.tsx'
import { DATA } from '#app/data/portfolio.tsx'

const BLUR_FADE_DELAY = 0.04

const Hero = () => {
	return (
		<section id="hero" className="container">
			<div className="mx-auto w-full space-y-8">
				<div className="flex justify-between gap-2">
					<div className="flex flex-1 flex-col space-y-1.5">
						<BlurFadeText
							delay={BLUR_FADE_DELAY}
							className="text-3xl font-bold tracking-tighter sm:text-5xl xl:text-6xl/none"
							yOffset={8}
							text={`Hi, I'm ${DATA.name.split(' ')[0]} 👋`}
						/>
						<BlurFadeText
							className="max-w-[600px] md:text-xl"
							delay={BLUR_FADE_DELAY}
							text={DATA.description}
						/>
					</div>
					<BlurFade delay={BLUR_FADE_DELAY}>
						<Avatar className="size-28 border">
							<AvatarImage alt={DATA.name} src={DATA.avatarUrl} />
							<AvatarFallback>{DATA.initials}</AvatarFallback>
						</Avatar>
					</BlurFade>
				</div>
			</div>
		</section>
	)
}
export default Hero
